import {MatPaginatorIntl} from "@angular/material/paginator";
import {Injectable} from '@angular/core';

@Injectable()
export class CustomMatPaginatorIntl extends MatPaginatorIntl {
  constructor() {
    super();
    this.overrideLabels();
  }

  overrideLabels() {
    this.itemsPerPageLabel = "Elementi per pagina";
    this.nextPageLabel = "Avanti";
    this.previousPageLabel = "Indietro";
    this.lastPageLabel = "Ultima pagina";
    this.firstPageLabel = "Prima pagina";
    this.changes.next();
  }
}
